import { Leaderboard } from '@/components/customComponents'

import { useBoughtTogetherItems, useModifiersItems } from '@/hooks'
import { useReduxSalesLensFilter } from '@/store'
import { dateToString } from '@/utils'

interface BoughtTogetherTabProps {
  itemName: string
}

export const BoughtTogetherTab = ({ itemName }: BoughtTogetherTabProps) => {
  // Get filter state from Redux (sales lens specific)
  const { selectedBranch, date, sizeFilter, temperatureFilter } =
    useReduxSalesLensFilter()

  const {
    boughtTogetherItemsChartData,
    boughtTogetherItemsColumns,
    loading: boughtTogetherItemsLoading,
    error: boughtTogetherItemsError,
  } = useBoughtTogetherItems(
    dateToString(date, 'from'),
    dateToString(date, 'to'),
    selectedBranch,
    itemName,
    sizeFilter,
    temperatureFilter
  )

  const {
    modifiersItemsChartData,
    modifiersItemsColumns,
    loading: modifiersItemsLoading,
    error: modifiersItemsError,
  } = useModifiersItems(
    dateToString(date, 'from'),
    dateToString(date, 'to'),
    selectedBranch,
    itemName,
    sizeFilter,
    temperatureFilter
  )

  return (
    <div className="space-y-6">
      <div>
        <Leaderboard
          title="Bought Together"
          data={boughtTogetherItemsChartData}
          loading={boughtTogetherItemsLoading}
          columns={boughtTogetherItemsColumns}
          enablePagination={true}
          itemsPerPage={5}
          sortBy="count"
        />
      </div>
      <div>
        <Leaderboard
          title="Modifiers"
          data={modifiersItemsChartData}
          loading={modifiersItemsLoading}
          columns={modifiersItemsColumns}
          enablePagination={true}
          itemsPerPage={5}
          sortBy="count"
        />
      </div>
    </div>
  )
}
